import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import configMenu from '../configMenu.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { guid } from '@/utils';
export default {
  name: 'swipe_magic_nav_config',
  components: {
    uploadFile: uploadFile,
    draggable: draggable,
    pictureLibrary: pictureLibrary,
    configMenu: configMenu
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    tabListFlat: Array,
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureList: [],
      updateIndex: 0,
      depot: {},
      defaultValue: {
        imageurl: '',
        title: '',
        title_color: '',
        btn_text: '',
        btn_color: '',
        link_type: '1',
        link_value: '',
        goods_id: '',
        module_plate_id: '',
        sort: '',
        wx_appid: '',
        wx_path: ''
      },
      rules: {
        value: [{
          required: true,
          validator: function validator(_, value, callback) {
            if (value.length < 3) callback('至少添加三个图片模块');
            callback();
          }
        }],
        margin_top: [{
          type: 'number',
          message: '间距必须为数字值'
        }],
        z_index: [{
          required: true,
          pattern: /^(?:[1-9]|[1-9][0-9])$/,
          message: '请输入1-99之间的整数！'
        }]
      }
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.value[this.updateIndex]['imageurl'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(index) {
      this.$refs.uploadBanner[index].uploadBanner();
    },
    addUpload: function addUpload() {
      this.value.config.value.push(_objectSpread(_objectSpread({}, this.defaultValue), {}, {
        uid: guid()
      }));
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.imageurl = "".concat(this.$ossurl).concat(res);
    },
    //删除图片
    handleDelUpload: function handleDelUpload(index) {
      var _this2 = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config.value.splice(index, 1);
      }).catch(function () {});
    }
  },
  created: function created() {
    var _this3 = this;
    this.getPicture();
    var value = Array.from({
      length: 3
    }, function (_, index) {
      return _objectSpread(_objectSpread({}, _this3.defaultValue), {}, {
        imageurl: {
          0: 'https://res.youlianfuwu.com/mini_program/s-caketoday.jpg',
          1: 'https://res.youlianfuwu.com/mini_program/s-caketodoor.jpg',
          2: 'https://res.youlianfuwu.com/mini_program/s-caketohome.jpg'
        }[index],
        title: {
          0: '当日达',
          1: '到店消费',
          2: '蛋糕到家'
        }[index],
        uid: guid()
      });
    });
    this.$set(this.value, 'config', _objectSpread({
      value: value,
      margin_top: 15,
      z_index: 2
    }, this.value.config));
  }
};